import { render, staticRenderFns } from "./ServiceRevenueStatistics.vue?vue&type=template&id=5ac33ca5"
import script from "./ServiceRevenueStatistics.vue?vue&type=script&lang=ts"
export * from "./ServiceRevenueStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports